module.exports = __webpack_public_path__ + "static/img/novideo.68a7942.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/novideo.png
// module id = rNnF
// module chunks = 18